import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Warehouse from 'components/Warehouse'

const Final = () => {
  const { t } = useTranslation('warehouse')
  const { push } = useHistory()

  return (
    <div
      className='resignation__main'
      style={{ paddingTop: 0 }}>
      <div className='title'>
        <div>{t('thankYou')}</div>
        <div>{t('rentalCompleted')}</div>
      </div>

      <div className='resignation__summary'>
        <div className='resignation__warehouses'>
          {[1, 2, 3].map(e => <div
            key={e}
            className={`warehouse${e === 1 ? ' --left' : e === 3 ? ' --right' : ''}`}>
            <Warehouse />
          </div>)}
        </div>

        <div className='resignation__text'>{t('shareYourOpinionAndHelpUsImproveOurCompany')}</div>
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          text={t('rateUs')}
          action={() => { }}
        />

        <BackBtn
          text={t('homePage')}
          action={() => push('/')}
        />
      </div>
    </div>
  )
}

export default Final